import React from 'react';

export default function CloverIcon({ width = 32, height = 32, className = "", style = {} }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 219 220"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g filter="url(#filter0_d_2167_514)">
        <path
          d="M174.155 86.6933C165.292 95.5566 149.028 103.421 142.221 106.027C171.113 108.417 190.448 105.158 201.309 94.2966C212.171 83.4348 231.534 48.5417 198.051 17.1775C163.727 -14.9736 129.404 5.01216 118.542 20.6532C109.853 33.1661 110.432 59.0318 112.025 70.1833C114.704 64.8972 122.409 51.6312 130.056 42.5942C139.614 31.2978 162.207 26.5187 176.11 41.2908C190.013 56.0629 185.234 75.6142 174.155 86.6933Z"
          fill="white"
        />
        <path
          d="M174.155 86.6933C165.292 95.5566 149.028 103.421 142.221 106.027C171.113 108.417 190.448 105.158 201.309 94.2966C212.171 83.4348 231.534 48.5417 198.051 17.1775C163.727 -14.9736 129.404 5.01216 118.542 20.6532C109.853 33.1661 110.432 59.0318 112.025 70.1833C114.704 64.8972 122.409 51.6312 130.056 42.5942C139.614 31.2978 162.207 26.5187 176.11 41.2908C190.013 56.0629 185.234 75.6142 174.155 86.6933Z"
          fill="url(#paint0_linear_2167_514)"
          fillOpacity="0.28"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M89.6797 172.037C98.543 163.174 104.669 147.779 107.276 140.973C109.666 169.865 106.804 187.06 96.8485 198.758C84.4359 213.343 53.4011 229.171 20.5983 196.368C-12.6567 163.113 5.14434 125.362 24.0741 116.859C37.9708 110.617 65.0595 110.487 76.211 112.08C70.9249 114.759 55.0521 120.726 46.015 128.373C33.0387 139.353 28.6361 161.827 43.4082 175.731C58.1804 189.634 78.6006 183.117 89.6797 172.037Z"
          fill="white"
        />
        <path
          d="M89.6797 172.037C98.543 163.174 104.669 147.779 107.276 140.973C109.666 169.865 106.804 187.06 96.8485 198.758C84.4359 213.343 53.4011 229.171 20.5983 196.368C-12.6567 163.113 5.14434 125.362 24.0741 116.859C37.9708 110.617 65.0595 110.487 76.211 112.08C70.9249 114.759 55.0521 120.726 46.015 128.373C33.0387 139.353 28.6361 161.827 43.4082 175.731C58.1804 189.634 78.6006 183.117 89.6797 172.037Z"
          fill="url(#paint1_linear_2167_514)"
          fillOpacity="0.28"
          style={{ mixBlendMode: 'screen' }}
        />
        <path
          d="M179.369 110.589L137.442 109.503C160.16 114.591 181.975 132.748 185.234 143.827C188.493 154.906 184.148 183.147 156.559 184.233C128.97 185.319 118.977 156.644 116.153 143.827C113.893 133.573 115.284 102.117 115.284 102.117C99.2081 105.159 60.3562 106.713 43.8125 86.6934C27.2689 66.6739 33.6024 49.5458 42.0747 41.0736C50.6823 32.466 74.6602 26.7359 87.0427 40.8563C96.9488 52.1527 104.494 71.9213 107.029 80.3935C107.318 74.6005 107.811 60.4946 107.463 50.4148C107.115 40.335 104.856 30.429 103.77 26.7359C102.249 22.3188 95.515 11.8769 80.7429 5.44669C65.9707 -0.983525 48.9538 2.62261 42.2919 5.22946C33.1679 8.4156 13.3185 19.9521 6.91237 40.609C-1.09527 66.4301 7.53394 82.5659 18.1786 94.5139C28.8232 106.462 43.8125 105.81 64.0156 106.896C84.2186 107.983 96.6492 109.696 101.38 110.372C105.942 111.024 106.811 114.5 107.463 116.455C107.859 117.644 111.518 157.151 113.111 176.847C118.309 203.334 138.571 211.865 150.042 213.777C159.58 215.367 180.268 213.964 192.837 203.567C205.407 193.17 213.822 177.803 216.082 164.247C218.341 150.692 213.04 132.53 202.396 121.886C193.88 113.37 183.496 110.807 179.369 110.589Z"
          fill="white"
        />
        <path
          d="M179.369 110.589L137.442 109.503C160.16 114.591 181.975 132.748 185.234 143.827C188.493 154.906 184.148 183.147 156.559 184.233C128.97 185.319 118.977 156.644 116.153 143.827C113.893 133.573 115.284 102.117 115.284 102.117C99.2081 105.159 60.3562 106.713 43.8125 86.6934C27.2689 66.6739 33.6024 49.5458 42.0747 41.0736C50.6823 32.466 74.6602 26.7359 87.0427 40.8563C96.9488 52.1527 104.494 71.9213 107.029 80.3935C107.318 74.6005 107.811 60.4946 107.463 50.4148C107.115 40.335 104.856 30.429 103.77 26.7359C102.249 22.3188 95.515 11.8769 80.7429 5.44669C65.9707 -0.983525 48.9538 2.62261 42.2919 5.22946C33.1679 8.4156 13.3185 19.9521 6.91237 40.609C-1.09527 66.4301 7.53394 82.5659 18.1786 94.5139C28.8232 106.462 43.8125 105.81 64.0156 106.896C84.2186 107.983 96.6492 109.696 101.38 110.372C105.942 111.024 106.811 114.5 107.463 116.455C107.859 117.644 111.518 157.151 113.111 176.847C118.309 203.334 138.571 211.865 150.042 213.777C159.58 215.367 180.268 213.964 192.837 203.567C205.407 193.17 213.822 177.803 216.082 164.247C218.341 150.692 213.04 132.53 202.396 121.886C193.88 113.37 183.496 110.807 179.369 110.589Z"
          fill="url(#paint2_linear_2167_514)"
          fillOpacity="0.28"
          style={{ mixBlendMode: 'screen' }}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2167_514"
          x="0"
          y="0"
          width="218.819"
          height="219.675"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2167_514"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2167_514"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2167_514"
          x1="81.1775"
          y1="211.823"
          x2="123.322"
          y2="14.5712"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.296403" stopColor="white" stopOpacity="0" />
          <stop offset="0.58" stopColor="#CCBFFF" stopOpacity="0.5" />
          <stop offset="0.763054" stopColor="#C3B7FF" stopOpacity="0.633698" />
          <stop offset="0.853832" stopColor="#BFB3FF" stopOpacity="0.7" />
          <stop offset="0.875" stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2167_514"
          x1="81.1775"
          y1="211.823"
          x2="123.322"
          y2="14.5712"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.296403" stopColor="white" stopOpacity="0" />
          <stop offset="0.58" stopColor="#CCBFFF" stopOpacity="0.5" />
          <stop offset="0.763054" stopColor="#C3B7FF" stopOpacity="0.633698" />
          <stop offset="0.853832" stopColor="#BFB3FF" stopOpacity="0.7" />
          <stop offset="0.875" stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2167_514"
          x1="81.1775"
          y1="211.823"
          x2="123.322"
          y2="14.5712"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.296403" stopColor="white" stopOpacity="0" />
          <stop offset="0.58" stopColor="#CCBFFF" stopOpacity="0.5" />
          <stop offset="0.763054" stopColor="#C3B7FF" stopOpacity="0.633698" />
          <stop offset="0.853832" stopColor="#BFB3FF" stopOpacity="0.7" />
          <stop offset="0.875" stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
}
